/**
 * Created by slava on 4/21/17.
 */

var MobageSocial = function (name, options) {
    Social.call(this, name || connector.MOBAGE, options);
};

MobageSocial.prototype = Object.create(Social.prototype);
MobageSocial.prototype.constructor = MobageSocial;

MobageSocial.HEIGHT = 860;

MobageSocial.prototype.isShareSupported = function () {
    return true;
};

MobageSocial.prototype.isInviteSupported = function () {
    return true;
};

MobageSocial.prototype.isSupportsNativeRequest = function () {
    return true;
};

MobageSocial.prototype._connect = function (callback) {
    gadgets.window.adjustHeight(MobageSocial.HEIGHT);

    var req = opensocial.newDataRequest();
    req.add(req.newFetchPersonRequest(opensocial.IdSpec.PersonId.VIEWER), "viewer");
    req.send(function (response) {
        if (response.hadError()) {
            // error
            callback(connector.STATUS_DISCONNECTED);
        } else {
            var item = response.get("viewer");
            if (item.hadError()) {
                // error
                callback(connector.STATUS_DISCONNECTED);
            } else {
                var viewer = item.getData();

                if (viewer.getId() === "mbga.jp:-1") {
                    // user is not logged in mobage/mobage session expired?
                    callback(connector.STATUS_DISCONNECTED);
                } else {
                    this.user = MobageSocial.formatUserData(viewer);
                    console.log(this.user);
                    callback(connector.STATUS_CONNECTED);
                }
            }
        }
    }.bind(this));
};

MobageSocial.prototype.isLoggedIn = function () {
    return true;
};

MobageSocial.prototype._getUserID = function () {
    return this.user && this.user.id;
};

MobageSocial.prototype.getAccessToken = function () {
    return "mbga";
};

MobageSocial.prototype._login = function (callback) {
    callback();
};

MobageSocial.prototype.sendActivity = function (data, callback) {
    var params = {};
    params[opensocial.Activity.Field.TITLE] = data.title;
    params[opensocial.Activity.Field.BODY] = data.body;
    var activity = opensocial.newActivity(params);
    opensocial.requestCreateActivity(activity, opensocial.CreateActivityPriority.LOW, function (response) {
        if (response.hadError()) {
            // console.log('Error sending activity', response);
            callback(connector.CODE_FAILED);
        } else {
            // console.log('ok', response);
            callback(connector.CODE_SUCCEED);
        }
    });
};

MobageSocial.prototype.invite = function (data, callback) {
    var params = {};
    params[opensocial.Message.Field.TITLE] = data.title;

    var reason = opensocial.newMessage(data.text, params);

    opensocial.requestShareApp(
        "VIEWER_FRIENDS",
        reason,
        function (data) {
            if (data.hadError()) {
                callback(connector.CODE_CANCELLED, data);
            } else {
                callback(connector.CODE_SUCCEED);
            }
        }
    );
};

MobageSocial.prototype.requestToOne = function (uid, data, callback) {
    var params = {};
    params[opensocial.Message.Field.TITLE] = data.title;

    var body = data.text;
    var message = opensocial.newMessage(body, params);
    var recipient = uid;

    opensocial.requestSendMessage(recipient, message, function (response) {
        if (response.hadError()) {
            callback(connector.CODE_CANCELLED);
        } else {
            var data = response.getData();
            if (data.recipientIds && data.recipientIds.length > 0) {
                callback(connector.CODE_SUCCEED);
            } else {
                callback(connector.CODE_CANCELLED);
            }
        }
    });
};

MobageSocial.prototype.request = function (data, callback) {
    var to = data.to;
    if (!Array.isArray(to)) {
        to = [to];
    }

    var sended = [];
    var sendOneRequest = function (id) {
        if (id === to.length) {
            callback(sended.length > 0 ? connector.CODE_SUCCEED : connector.CODE_CANCELLED, sended);
        } else {
            this.requestToOne(to[id], data, function (response) {
                if (response === connector.CODE_SUCCEED) {
                    sended.push(to[id]);
                }
                setTimeout(function () {
                    sendOneRequest(id + 1);
                }, 500);
            });
        }
    }.bind(this);
    sendOneRequest(0);
};

MobageSocial.prototype.share = function (data, callback) {
    var mediaItem = opensocial.newMediaItem("image/jpg", data.image);
    mediaItem.setField(opensocial.MediaItem.Field.TYPE, opensocial.MediaItem.Type.IMAGE);

    var params = {};
    params[mbga.Diary.Field.TITLE] = data.title;
    params[mbga.Diary.Field.CONTENT] = data.text;
    params[mbga.Diary.Field.MEDIA_ITEMS] = [mediaItem];
    var diary = mbga.newCreateDiary(params);

    mbga.requestCreateDiary(diary, function (response) {
        if (response.hadError()) {
            callback(connector.CODE_FAILED, response);
        } else {
            var diary = response.getData();
            var url = diary.getEntryURL();
            console.log(url);

            callback(url ? connector.CODE_SUCCEED : connector.CODE_CANCELLED);
        }
    });
};

MobageSocial.prototype.listFriendsByApp = function (inApp, callback) {
    var params = {};
    params[opensocial.DataRequest.PeopleRequestFields.MAX] = 1000;
    params[opensocial.DataRequest.PeopleRequestFields.PROFILE_DETAILS] = [
        opensocial.Person.Field.HAS_APP
    ];

    var reqParams = {};
    reqParams[opensocial.IdSpec.Field.USER_ID] = opensocial.IdSpec.PersonId.VIEWER;
    reqParams[opensocial.IdSpec.Field.GROUP_ID] = opensocial.IdSpec.GroupId.FRIENDS;
    var idSpec = opensocial.newIdSpec(reqParams);
    var req = opensocial.newDataRequest();

    req.add(req.newFetchPeopleRequest(idSpec, params), "friends");
    req.send(function (response) {
        if (response.hadError()) {
            callback(connector.CODE_FAILED);
        } else {
            var friends = response.get("friends").getData().asArray();

            // console.log(friends);

            friends = friends.filter(function (friend) {
                var hasApp = friend.getField(opensocial.Person.Field.HAS_APP);
                return hasApp === inApp;
            });

            callback(connector.CODE_SUCCEED, friends.map(MobageSocial.formatUserData));
        }
    });
};

MobageSocial.prototype._listFriends = function (callback) {
    this.listFriendsByApp(true, callback);
};

MobageSocial.prototype._listInvitableFriends = function (callback) {
    this.listFriendsByApp(false, callback);
};

MobageSocial.formatUserData = function (user) {
    var avatarUlr = "";
    var data = {
        id: user.getId(),
        name: user.getDisplayName()
    };

    try {
        avatarUlr = MobageSocial.proxyAvatar(user.getField(opensocial.Person.Field.THUMBNAIL_URL));
        data.avatar = avatarUlr;

        return data;
    } catch (e) {
        if (e instanceof TypeError || e.message && e.message.indexOf("of null") !== -1) {
            var info = e.message + " avatarUrl - " + avatarUlr
                + " reqUserId - " + data.id
                + " reqUserName - " + data.name
                + " stack - " + JSON.stringify(e.stack);
            throw new Error(info);
        } else {
            throw e;
        }
    }
};

MobageSocial.proxyAvatar = function (url) {
    var base = connector.platform.getExternalUrl("proxy");

    var parsed = url.match(/.*profile(.*)/);

    return base + parsed[1];
};

MobageSocial.prototype._aboutMe = function (callback) {
    if (this.user) {
        callback(connector.CODE_SUCCEED, this.user);
    } else {
        callback(connector.CODE_FAILED);
    }
};

MobageSocial.CODE_SUCCEED = "ok";
